<template>
    <button
        :disabled="disabled"
        v-on="$listeners"
    >
      <component
        :is="linkComponent"
        :class="clsx('violet-fancy-button', { 'violet-fancy-button--disabled': disabled })"
        v-bind="linkProps"
      >
        <slot />
      </component>
    </button>
</template>

<script>
import clsx from 'clsx';
import { HashAnchor, SmartLink } from '@/shared/ui/link';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    target: {
      type: String,
      default: '_self',
      validator(value) { return ['_blank', '_self', '_parent', '_top'].includes(value); },
    },
    method: {
      type: Function,
      default: null,
    },
    event: {
      type: String,
      default: null,
    },
    hash: {
      type: String,
      default: null,
    },
  },
  methods: { clsx },
  components: { SmartLink, HashAnchor },
  computed: {
    linkComponent() {
      if (this.hash && !this.url && !this.route) {
        return 'HashAnchor';
      }

      return 'SmartLink';
    },
    linkProps() {
      const props = {
        disabled: this.disabled,
      };
      if (this.linkComponent === 'HashAnchor') {
        return {
          ...props,
          hash: this.hash,
        };
      } else {
        return {
          ...props,
          url: this.url,
          route: this.route,
          target: this.target,
          method: this.method,
          event: this.event,
          hash: this.hash,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.violet-fancy-button {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #3DABDE;
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    border-radius: 16px;
    padding: 16px 24px;
    width: 100%;
    transition: background 0.3s ease;

    &:hover {
        background: #2E9BCF;
    }
}
</style>
